const FieldError = ({error}) => {

    return <span class="invalid-feedback d-flex">{ error }</span> 
}

export default FieldError